import { Controller } from '@hotwired/stimulus';
import checkSvg  from '../../images/icons/check.svg';

export default class extends Controller {

    connect() {
        this.element.addEventListener('click', async () => {
            const copyContent = async () => {
                let el = document.querySelector(this.element.dataset.content);
                let range = document.createRange();
                range.selectNode(el);

                window.getSelection().removeAllRanges();
                window.getSelection().addRange(range);

                document.execCommand('copy');
                window.getSelection().removeAllRanges();
            }

            await copyContent();
            this.showSuccess();
        });
    }

    showSuccess() {
        if (this.resetTimeout) {
            clearTimeout(this.resetTimeout);
        } else {
            this.originalContent = this.element.innerHTML;
        }

        this.element.innerHTML = `<img src="${checkSvg}" alt="Close">`;

        this.resetTimeout = setTimeout(() => {
            this.element.innerHTML = this.originalContent;
            this.resetTimeout = null;
        }, 2000);
    }
}
